import { render, staticRenderFns } from "./Videos.vue?vue&type=template&id=1afb6320&scoped=true"
import script from "./Videos.vue?vue&type=script&lang=js"
export * from "./Videos.vue?vue&type=script&lang=js"
import style0 from "./Videos.vue?vue&type=style&index=0&id=1afb6320&prod&scoped=true&lang=scss"
import style1 from "./Videos.vue?vue&type=style&index=1&id=1afb6320&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afb6320",
  null
  
)

export default component.exports